export const SET_USER_SUCCESS = 'SET_USER_SUCCESS';
export const SET_USER_FAILURE = 'SET_USER_FAILURE';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

// export const SET_SOCIAL_USER_SUCCESS = 'SET_SOCIAL_USER_SUCCESS';
// export const SET_SOCIAL_USER_FAILURE = 'SET_SOCIAL_USER_FAILURE';

// export const SET_USER_FORM_VALUES_SUCCESS = 'SET_USER_FORM_VALUES_SUCCESS';
// export const SET_USER_FORM_VALUES_FAILURE = 'SET_USER_FORM_VALUES_FAILURE';

// export const SET_PLAN_CODE_SUCCESS = 'SET_PLAN_CODE_SUCCESS';
// export const SET_PLAN_CODE_FAILURE = 'SET_PLAN_CODE_FAILURE';

// export const SET_PAYMENT_METHOD_SUCCESS = 'SET_PAYMENT_METHOD_SUCCESS';
// export const SET_PAYMENT_METHOD_FAILURE = 'SET_PAYMENT_METHOD_FAILURE';
